import { Button, message } from 'antd';
import React from 'react';

import { deleteInstructor } from '../../helpers/api';

const DeleteInstructorButton: React.FC<{
  updateData: () => void;
  id: string;
}> = ({ updateData, id }) => {
  const handleDelete = async (id: string) => {
    try {
      await deleteInstructor(id);
      message.success('刪除成功');
      updateData();
    } catch (error) {
      message.error('刪除失敗');
    }
  };

  return (
    <Button type="primary" danger onClick={() => handleDelete(id)}>
      刪除
    </Button>
  );
};

export default DeleteInstructorButton;
